<template>
  <div class="absolute hidden" />
</template>

<script setup lang="ts">
import emitter from 'tiny-emitter/instance.js';

const props = defineProps<{
  color?: string
}>();

emitter.emit('global:set-color', props.color);
</script>
